import React, { useState } from "react";
import ModalCommon from "../ModalCommon";
import WarningImage from "../../asset/images/Freeze/warning.svg";
import FailedAns from "../../asset/images/Freeze/Group 239071.svg";
import QuesMark from "../../asset/images/Freeze/Group 240169.svg";
import SuccessSubmitt from "../../asset/images/Freeze//Group 239072.svg";
import FreezeUnfreezeStatus from "./FreezeUnfreezeStatus";
import ValidateUser from "./ValidateUser";
import VerificationQNA from "./VerificationQNA";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../CommonMethhods/CommonMethods";
import { Freeze_Unfreeze } from "../../Configuration/API_URL";
import { toast } from "react-toastify";

function FNUParent() {
  const [modalState, setModalState] = useState({ modal: false, data: {} });
  const [pageStatus, setPageStatus] = useState("user");
  const [skipData, setSkipData] = useState(null);
  const [qaeRes, setQaeRes] = useState();
  const [data, setData] = useState({ pan: "", mobile: "" });
  const [freezStatus, setFreezStatus] = useState(false);

  const modalData = {
    alreadyProcess: {
      icon: WarningImage,
      text: "",
      button: { primary: "Okay", secondary: null },
      // onPrimaryClick: () => { },
    },
    cancelRequest: {
      icon: WarningImage,
      text: `Are you sure you want to cancel request to  ${
        freezStatus ? "unfreeze" : "freeze"
      }  user’s account?`,
      button: { primary: "YES", secondary: "NO" },
      // onPrimaryClick: () => setPageStatus("fnuPage"),
    },
    sureToFreezeAccount: {
      icon: QuesMark,
      text: `Are you sure you want to  ${
        freezStatus ? "unfreeze" : "freeze"
      } the user’s account? `,
      button: { primary: "YES", secondary: "NO" },
      // onPrimaryClick: () => { UpdateFreezUnfreezStatus() },
    },
    requestFreezeAccountSubmitted: {
      icon: SuccessSubmitt,
      text: `The request to ${
        freezStatus ? "unfreeze" : "freeze"
      }  your account has been submitted successfully!`,
      button: { primary: "Okay", secondary: null },
      // onPrimaryClick: () => { },
    },

    userFailedToAnsQues: {
      icon: FailedAns,
      text: "User failed to answer 3 security questions correctly! Try again later",
      button: { primary: "Cancel Request", secondary: null },
      // onPrimaryClick: () => { },
    },
  };

  return (
    <>
      {pageStatus === "fnuPage" && (
        <FreezeUnfreezeStatus
          setModalState={setModalState}
          modalData={modalData}
          setPageStatus={setPageStatus}
          qaeRes={qaeRes}
          data={data}
          freezStatus={freezStatus}
        />
      )}
      {pageStatus === "user" && (
        <ValidateUser
          setModalState={setModalState}
          modalData={modalData}
          setPageStatus={setPageStatus}
          setSkipData={setSkipData}
          setData={setData}
          setFreezStatus={setFreezStatus}
        />
      )}
      {pageStatus === "verficationQNA" && (
        <VerificationQNA
          setPageStatus={setPageStatus}
          skipData={skipData}
          setQaeRes={setQaeRes}
          modalData={modalData}
          setModalState={setModalState}
          data={data}
          setFreezStatus={setFreezStatus}
        />
      )}
      <ModalCommon
        modalState={modalState}
        setModalState={setModalState}
        modalData={modalData}
      />
    </>
  );
}

export default FNUParent;
